function convertRemToPixels(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

async function initParticles(containerId) {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('[Particles] Container not found:', containerId);
    return null;
  }

  const [ { tsParticles }, { loadSlim } ] = await Promise.all([
      import('@tsparticles/engine'),
      import('@tsparticles/slim'),
  ]);
  await loadSlim(tsParticles);

  await tsParticles.load({
    id: containerId,
    options: {
      fullScreen: {
        enable: false
      },
      particles: {
        move: {
          enable: true
        },
        number: {
          value: 50
        },
        opacity: {
          value: { min: 0.3, max: 1 }
        },
        shape: {
          type: ["circle", "square", "triangle", "polygon"],
          options: {
            polygon: [
              {
                sides: 5
              },
              {
                sides: 6
              },
              {
                sides: 8
              }
            ]
          }
        },
        size: {
          value: { min: 1, max: 3 }
        },
        color: {
          value: ['#cfd3dc', '#b9bfd3', '#9aa0b5']
        },
        links: {
          enable: true,
          color: "#cfd3dc"
        }
      }
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  // Track Mouse.
  const radius = convertRemToPixels(20);
  document.querySelectorAll('.track-mouse').forEach((el: Element & { offsetParent: number; style: CSSStyleDeclaration }) => {
    // If element is svg.
    if (el.tagName.toLowerCase() === 'svg') {
      const grad = el.querySelector('radialGradient');
      document.addEventListener('mousemove', e => {
        const rect = el.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        if (grad) {
          grad.setAttribute('fx', `${x}%`);
          grad.setAttribute('fy', `${y}%`);
          grad.setAttribute('cx', `${x}%`);
          grad.setAttribute('cy', `${y}%`);
        }
      });
      return;
    }
    document.addEventListener('mousemove', e => {
      if (!el.offsetParent) return; // Skip if not visible
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      if (x < -radius || x > rect.width + radius || y < -radius || y > rect.height + radius) {
        return; // Skip if out of bounds with margin
      }
      el.style.setProperty('--mouse-x', `${x}px`);
      el.style.setProperty('--mouse-y', `${y}px`);
    });
  });

  document.querySelectorAll('nav .burger').forEach(burger => {
    burger.addEventListener('click', () => {
      const nav = burger.closest('nav').querySelector('.nav-links');
      if (nav) {
        nav.classList.toggle('open');
      }
    });
  });

  document.querySelectorAll('.hoverRubberBand').forEach((el: HTMLElement) => {
    el.addEventListener('mouseover', () => {
      el.classList.add('animated', 'rubberBand');
    });
    el.addEventListener('animationend', () => {
      el.classList.remove('animated', 'rubberBand');
    });
  });

  if (window.innerWidth > 1120) {
    initParticles('particles-left').catch(err => {
      console.error('[Particles] Failed to init left particles:', err);
    });
    initParticles('particles-right').catch(err => {
      console.error('[Particles] Failed to init right particles:', err);
    });
  }
});
